import React from 'react';
import styled from 'styled-components';
import clientData from './clientData';

const Clients = () => {
    return (
        <Container>

            <div className="owl-carousel">
                {clientData.map(item => (
                    <img src={item.image} alt="image" />
                ))}
            </div>
        </Container>
    )
}

export default Clients


const Container = styled.div`
    background: #fff;
    .owl-carousel{
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 2rem;
        img{
            margin: 0rem 2rem;
        }
    }
`